import { c as _c } from "react/compiler-runtime";
import { Box, Flex, Stack } from '@repo/pandacss/jsx';
import { AnalyticsFeatureViewed } from '@repo/platform-analytics/AnalyticsFeatureViewed';
import { useAnalyticsSkuViewedContext } from '@repo/platform-analytics/AnalyticsSkuViewed/Context';
import { InfoTooltip } from '@repo/ui/composites/InfoTooltip';
import { Typography, type TypographyPropsBag } from '@repo/ui/Typography';
import { getApprovalLikelihoodLabel, getOddsLabel } from '../../lib/approvalOdds';
import type { Odds } from '../../model/approval-odds/types';
import { ApprovalOddsButton } from './ApprovalOddsButton';
export const ApprovalOddsLikelihoodContent = t0 => {
  const $ = _c(48);
  const {
    userCreditScore,
    odds,
    isAmexOffer,
    approvalLikelihood,
    typographyProps
  } = t0;
  const {
    skuImpressionId
  } = useAnalyticsSkuViewedContext();
  const {
    min,
    max
  } = odds;
  if (!userCreditScore || approvalLikelihood == null) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = {
        position: "relative"
      };
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = {
        flexDirection: {
          base: "column",
          _pcMd: "row"
        }
      };
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] !== isAmexOffer || $[3] !== max || $[4] !== min) {
      t3 = !isAmexOffer && <Typography>{min}-{max}</Typography>;
      $[2] = isAmexOffer;
      $[3] = max;
      $[4] = min;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = {
        ml: {
          base: "0",
          _pcMd: "1"
        }
      };
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    let t5;
    if ($[7] !== isAmexOffer || $[8] !== max || $[9] !== min) {
      t5 = !isAmexOffer ? `(${getOddsLabel(min, max)})` : getOddsLabel(min, max);
      $[7] = isAmexOffer;
      $[8] = max;
      $[9] = min;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    let t6;
    if ($[11] !== t5) {
      t6 = <Typography css={t4}>{t5}</Typography>;
      $[11] = t5;
      $[12] = t6;
    } else {
      t6 = $[12];
    }
    let t7;
    if ($[13] !== t3 || $[14] !== t6) {
      t7 = <Flex css={t2}>{t3}{t6}</Flex>;
      $[13] = t3;
      $[14] = t6;
      $[15] = t7;
    } else {
      t7 = $[15];
    }
    let t8;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <ApprovalOddsButton />;
      $[16] = t8;
    } else {
      t8 = $[16];
    }
    let t9;
    if ($[17] !== t7) {
      t9 = <Box css={t1}>{t7}{t8}</Box>;
      $[17] = t7;
      $[18] = t9;
    } else {
      t9 = $[18];
    }
    return t9;
  }
  let T0;
  let label;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[19] !== approvalLikelihood || $[20] !== skuImpressionId) {
    label = getApprovalLikelihoodLabel(approvalLikelihood);
    T0 = AnalyticsFeatureViewed;
    t2 = "cc_approval_odds";
    t3 = "";
    t4 = skuImpressionId;
    t5 = 0;
    t1 = label.toLowerCase();
    $[19] = approvalLikelihood;
    $[20] = skuImpressionId;
    $[21] = T0;
    $[22] = label;
    $[23] = t1;
    $[24] = t2;
    $[25] = t3;
    $[26] = t4;
    $[27] = t5;
  } else {
    T0 = $[21];
    label = $[22];
    t1 = $[23];
    t2 = $[24];
    t3 = $[25];
    t4 = $[26];
    t5 = $[27];
  }
  let t6;
  if ($[28] !== t1) {
    t6 = {
      approval_odds: t1
    };
    $[28] = t1;
    $[29] = t6;
  } else {
    t6 = $[29];
  }
  const t7 = typographyProps?.css;
  let t8;
  if ($[30] !== t7) {
    t8 = {
      display: "inline",
      textTransform: "capitalize",
      ...t7
    };
    $[30] = t7;
    $[31] = t8;
  } else {
    t8 = $[31];
  }
  let t9;
  if ($[32] !== label || $[33] !== t8) {
    t9 = <Typography css={t8}>{label}</Typography>;
    $[32] = label;
    $[33] = t8;
    $[34] = t9;
  } else {
    t9 = $[34];
  }
  let t10;
  if ($[35] !== label) {
    t10 = <InfoTooltip ariaLabel="More information about your approval likelihood" text={<p>We think your odds of getting approved for this card are<strong> {label} </strong>based on your credit score and other factors. That said, these odds are an estimate to help you narrow your choices, not a guarantee. Card issuers may use different criteria than we do.</p>} />;
    $[35] = label;
    $[36] = t10;
  } else {
    t10 = $[36];
  }
  let t11;
  if ($[37] !== t10 || $[38] !== t9) {
    t11 = <Stack direction="row" gap="1">{t9}{t10}</Stack>;
    $[37] = t10;
    $[38] = t9;
    $[39] = t11;
  } else {
    t11 = $[39];
  }
  let t12;
  if ($[40] !== T0 || $[41] !== t11 || $[42] !== t2 || $[43] !== t3 || $[44] !== t4 || $[45] !== t5 || $[46] !== t6) {
    t12 = <T0 entityName={t2} entitySection={t3} parentActivityId={t4} impressionPosition={t5} additionalAttributes={t6}>{t11}</T0>;
    $[40] = T0;
    $[41] = t11;
    $[42] = t2;
    $[43] = t3;
    $[44] = t4;
    $[45] = t5;
    $[46] = t6;
    $[47] = t12;
  } else {
    t12 = $[47];
  }
  return t12;
};